import { IGroupLeanListModel, IGroupLeanModel, } from "models/group/group-lean.model";
import { GroupTypeFilterValues } from "../../components/group/group-filter/group-type-filter.component";
import { IGroupModel } from "../../models/group/group.model";
import { IGroup } from "../group/group";
import { IGroupLean, IGroupOrManufacturerList } from "../group/group-lean";
import { GroupType } from "../group/group-type";
import { GroupContractConverter } from "./group-contract.converter";

export class GroupConverter {
  public static toModel(group: IGroup): IGroupModel {
    const groupTypes = [group.type];

    return {
      active: group.active ?? null,
      erpNumber: group.erpNumber,
      name: group.name,
      invoiceAddress: group.invoiceAddress ?? null,
      groupTypes: groupTypes,
      vatId: group.vatId ?? null,
      tradeRegisterNumber: group.tradeRegisterNumber ?? null,
      agencyGroups: null,
      pomContracts: group.pomContracts
        ? group.pomContracts.map(GroupContractConverter.toModel)
        : group.pomContracts,
      isPomAgencyAnnouncer: group.isPomAgencyAnnouncer,
      agencyErpNumber: group.agencyErpNumber,
      agencyName: group.agencyName,
    };
  }

  static toDomain(group: IGroupModel): IGroup {
    // for now, group can only support one group type
    const type = group.groupTypes[0];
    return {
      active: group.active,
      erpNumber: group.erpNumber,
      name: group.name ?? "",
      invoiceAddress: group.invoiceAddress ?? null,
      type,
      vatId: group.vatId ?? undefined,
      tradeRegisterNumber: group.tradeRegisterNumber ?? undefined,
      agencyGroup:
        group.agencyGroups?.length === 1 && group.agencyGroups[0] != null
          ? GroupConverter.toDomain(group.agencyGroups[0])
          : undefined,
      pomContracts: group.pomContracts
        ? group.pomContracts.map(GroupContractConverter.toDomain)
        : group.pomContracts,
      isPomAgencyAnnouncer: group.isPomAgencyAnnouncer,
      agencyName: group.agencyName,
      agencyErpNumber: group.agencyErpNumber,
    };
  }

  public static groupOrManufacturerToDomain(model: IGroupLeanModel): IGroupLean {
    return {
      groupType: model.groupTypes?.[0] ?? null,
      active: model.active,
      displayAddress: model.displayAddress,
      name: model.name,
      erpNumber: model.erpNumber,
      hasActiveUsers: model.hasActiveUsers,
      agencyName: model.agencyName,
    };
  }

  public static groupOrManufacturerListToDomain(model: IGroupLeanListModel): IGroupOrManufacturerList {
    return {
      meta: {
        page: model.meta.page,
        numberOfPages: model.meta.numberOfPages,
        numberOfRecords: model.meta.numberOfRecords,
        pageSize: model.meta.pageSize,
      },
      items: model.items.map(GroupConverter.groupOrManufacturerToDomain),
    };
  }

  public static groupTypesToGroupTypeFilterValues(groupType: GroupType | undefined): GroupTypeFilterValues | undefined {
    switch (groupType) {
      case GroupType.Customer:
        return GroupTypeFilterValues.Customer;
      case GroupType.PomAgency:
        return GroupTypeFilterValues.PomAgency;
      case GroupType.PomAgencyMember:
        return GroupTypeFilterValues.PomAgencyMember;
      case GroupType.PomRepresentative:
        return GroupTypeFilterValues.PomRepresentative;
      default:
        return undefined;
    }
  }

  public static groupTypeFilterValuesToGroupTypes(groupType: GroupTypeFilterValues | undefined): GroupType | undefined {
    switch (groupType) {
      case GroupTypeFilterValues.Customer:
        return GroupType.Customer;
      case GroupTypeFilterValues.PomAgency:
        return GroupType.PomAgency;
      case GroupTypeFilterValues.PomAgencyMember:
        return GroupType.PomAgencyMember;
      case GroupTypeFilterValues.PomRepresentative:
        return GroupType.PomRepresentative;
      default:
        return undefined;
    }
  }
}
